import { createUserMessagesModule } from '@izimi/modules';
import { userMessagesApi } from 'core/di';

export const messageModule = createUserMessagesModule({ userMessagesApi });
